import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface GetNextPasswordValidationAttemptDatePararms {
  username: string;
}

// Just a date
export interface GetNextPasswordValidationAttemptDateResult extends IResult {
}

export class GetNextPasswordValidationAttemptDate extends Request<GetNextPasswordValidationAttemptDatePararms, GetNextPasswordValidationAttemptDateResult> {
  constructor(username: string) {
    super('getNextPasswordValidationAttemptDate', {username: username});
  }
}
